export default {
    set frequency(frequency) {
        this._frequency = frequency;
    },

    get frequency() {
        return this._frequency;
    },

    set cart(cart) {
        console.log('cart', cart);

        this._cart = cart;
    },

    get cart() {
        const cart = this._cart;
        if (!cart) {
            return null;
        }

        return cart;
    },

    set product(product) {
        this._product = product;
    },

    get product() {
        return this._product;
    },

    set selling_plan_id(selling_plan_id) {
        this._selling_plan_id = +selling_plan_id;
    },

    get selling_plan_id() {
        return this._selling_plan_id;
    },

    set quantity(quantity) {
        this._quantity = quantity;
    },

    get quantity() {
        return this._quantity;
    },

    get default_quantity() {
        return this._default_quantity;
    },

    get selling_plan_groups() {
        const {product} = this;
        if (!product) {
            return [];
        }

        const selling_plan_groups = product?.selling_plan_groups;
        if (!selling_plan_groups) {
            return [];
        }

        if (!selling_plan_groups?.length) {
            return [];
        }

        return selling_plan_groups
            .map((group) => ({
                ...group,
                selling_plans: group?.selling_plans || [],
            }))
            .filter((group) => group.selling_plans.length > 0);
    },

    get cart_subscription_items() {
        const cart = this.cart;
        if (!cart) {
            return 0;
        }

        const items = cart?.items;
        if (!items) {
            return 0;
        }

        if (!items?.length) {
            return 0;
        }

        return items?.filter((item) => {
            return !!item?.selling_plan_allocation;
        })?.filter((item) => {
            const properties = item?.properties;
            if (!properties) {
                return true;
            }

            const keys = Object?.keys(properties);
            if (!keys) {
                return true;
            }

            if (!keys?.length) {
                return true;
            }

            if (!!`%%%${keys.join('%%%') || ''}`?.includes('%%%_rc')) {
                return false;
            }

            if (!keys?.includes('_inveterate_subscription')) {
                return true;
            }

            return !properties?._inveterate_subscription;
        }) || [];
    },

    get membership_already_in_cart() {
        const {cart} = this;
        if (!cart) {
            return 0;
        }

        const items = cart?.items;
        if (!items) {
            return 0;
        }

        if (!items?.length) {
            return 0;
        }

        return !!items?.filter((item) => {
            return !!item?.selling_plan_allocation;
        })?.find((item) => {
            const properties = item?.properties;
            if (!properties) {
                return false;
            }

            const keys = Object?.keys(properties) || [];
            if (!keys) {
                return false;
            }

            if (!keys?.length) {
                return false;
            }

            if (!keys?.includes('_inveterate_subscription')) {
                return false;
            }

            return !!properties?._inveterate_subscription;
        });
    },

    get lash_subscription_items() {
        const cart_subscription_items = this.cart_subscription_items;
        if (!cart_subscription_items) {
            return 0;
        }

        if (!cart_subscription_items?.length) {
            return 0;
        }

        return cart_subscription_items?.filter((item) => {
            const properties = item?.properties || {};
            if (!properties) {
                return false;
            }

            const keys = Object?.keys(properties) || [];
            if (!keys) {
                return false;
            }

            if (!keys?.length) {
                return false;
            }

            if (!keys?.includes('_is_lash')) {
                return false;
            }

            const is_lash = properties['_is_lash'];
            if (!is_lash) {
                return false;
            }

            return is_lash === "1" || is_lash === true;
        })?.filter((item) => {
            const properties = item?.properties;
            if (!properties) {
                return true;
            }

            const keys = Object?.keys(properties) || [];
            if (!keys) {
                return true;
            }

            if (!keys?.length) {
                return true;
            }

            return !keys?.includes('_subscription_upsell');
        }) || [];
    },

    get cart_total_subscriptions_quantity() {
        const {cart_subscription_items} = this;
        if (!cart_subscription_items) {
            return 0;
        }

        if (!cart_subscription_items?.length) {
            return 0;
        }

        return cart_subscription_items?.reduce((total, item) => {
            return total + (item?.quantity || 0);
        }, 0) || 0;
    },

    get total_subscription_quantity() {
        const cart_total_subscriptions_quantity =
            this.cart_total_subscriptions_quantity;

        if (this.purchaseType === "subscription") {
            return cart_total_subscriptions_quantity + this.quantity;
        }

        return cart_total_subscriptions_quantity;
    },

    get cart_total_lashes_quantity() {
        const lash_subscription_items = this.lash_subscription_items;
        if (!lash_subscription_items) {
            return 0;
        }

        if (!lash_subscription_items?.length) {
            return 0;
        }

        return lash_subscription_items?.reduce((total, item) => {
            return total + (item?.quantity || 0);
        }, 0) || 0;
    },

    get total_lashes_quantity() {
        return this.cart_total_lashes_quantity || 0;
    },

    get has_subscription() {
        // Liquid decides whether the subscribe option is offered (theme setting
        // "Retail pricing only" turns it off); follow it so the JS layout matches
        // what was rendered.
        if (this.container?.dataset?.subscriptionOption === '0') {
            return false;
        }

        const {selling_plan_groups} = this;
        if (!selling_plan_groups) {
            return false;
        }

        return !!selling_plan_groups?.length;
    },

    get currentVariant() {
        return this._currentVariant;
    },

    set currentVariant(currentVariant) {
        this._currentVariant = currentVariant;
    },

    get purchaseType() {
        const purchaseType = this._purchaseType;
        if (!purchaseType) {
            return this.isMembershipProduct ? "subscription" : "onetime";
        }

        return this._purchaseType;
    },

    set purchaseType(purchaseType) {
        this._purchaseType = purchaseType;
    },

    get lashSettings() {
        return this._lashSettings;
    },

    set lashSettings(lashSettings) {
        this._lashSettings = lashSettings;
    },
};
